// removed by extract-text-webpack-plugin
module.exports = {"form":"SearchForm__form__1LhdG","container":"SearchForm__container__Gs4M7","searchInput":"SearchForm__searchInput__-bTlF","search":"SearchForm__search__2UnNC","icon":"SearchForm__icon__1m42J","searchBtn":"SearchForm__searchBtn__ufMKI"};


//////////////////
// WEBPACK FOOTER
// ./src/SearchForm/SearchForm.css
// module id = 57
// module chunks = 0